import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDSelectBox from "components/MDSelectBox";
import React, { useContext, useEffect, useState } from "react";
import { initialValues } from "./schemas/initialValue";
import { ValidationSchema } from "./schemas/validation";
import { useFormik } from "formik";
import ImageUploader from "components/MDImageUploader";
import { ModalContext } from "context/ModalContext";
import PropTypes from "prop-types";
import { addBusinessApi } from "Apis/businessApi";
import { BusinessContext } from "context/BusinessContext";
import { updateBusinessDataApi } from "Apis/businessApi";
import { LoginFormContext } from "context/LoginFormContext";
import { Grid } from "@mui/material";
import MDTextField from "components/MDTextField";
import { MemberContext } from "context/MemberContext";
import MDGoogleMap from "components/MDGoogleMap";
import SingleCheckbox from "components/MDCheckBox/MDSingleCheckBox";
import MDTelInput from "components/MDTelInput";
import { statusData } from "helpers/constant";
import SubmitButton from "components/SubmitButton";
import { getBusinessSubcategoriesApi } from "Apis/businessApi";
import DraggableServiceForm from "../serviceDragList";
import Iconify from "components/Iconify";

const BusinessForm = ({ getbusinessAllData }) => {
  const [category, setCategory] = useState([]);
  const [subCategory, setSubCategory] = useState([]);
  const {
    editData,
    categoriesList,
    setCategoriesList,
    subCategoriesList,
    setSubCategoriesList,
    getCategoryApi,
    getSubCategoryApi,
  } = useContext(BusinessContext);
  const { setOpen, formIsEdit, setFormIsEdit } = useContext(ModalContext);
  const { setNotification, profileImage, setProfileImage } = useContext(LoginFormContext);
  const [serviceProfile, setServiceProfile] = useState([]);
  const { parentMemberList } = useContext(MemberContext);
  const [status, setStatus] = useState({
    label: "Inactive",
    value: "0",
  });
  const [member, setMember] = useState(null);
  const [selectedPosition, setSelectedPosition] = useState();
  const [isVerified, setIsVerified] = useState(0);
  const [phoneNumber, setPhoneNumber] = useState("+91");
  const [whatsAppNumber, setWhatsAppNumber] = useState("+91");
  const [subcategories, setSubcategories] = useState();

  const setDataInFormik = async () => {
    formik.setValues(editData);
    formik.setFieldValue("logo", editData?.business_images[0]?.image.split("/").pop());

    editData?.business_services?.map((item, index) => {
      // ✅ match the path used in DraggableLinkForm's ImageUploader
      formik.setFieldValue(
        `business_services[${index}].service_image`,
        editData?.business_services[index]?.business_service_images[0]?.service_image
          .split("/")
          .pop()
      );

      setServiceProfile((prev) => [
        ...prev,
        {
          url: editData?.business_services[index]?.business_service_images[0]?.service_image,
          name: null,
        },
      ]);
    });

    formik.setFieldValue("country_code", editData?.country_code);
    formik.setFieldValue("phone_number", editData?.phone_number);
    formik.setFieldValue("wp_number", editData?.wp_number);
    setPhoneNumber("+" + editData?.country_code + editData?.phone_number.toString());
    setWhatsAppNumber("+" + editData?.country_code + editData?.wp_number.toString());
    setIsVerified(editData?.is_verified);
    setProfileImage({
      url: editData?.business_images[0]?.image || null,
      name: null,
    });
  };

  const getStatusLabel = (id) => {
    const status = statusData.find((item) => item.value == id);
    return status ? status.label : "-";
  };

  const handleRemoveService = (index) => {
    const newService = formik?.values?.business_services?.filter((_, i) => i !== index);
    formik.setFieldValue("business_services", newService);
    setServiceProfile((prev) => {
      const validPrev = Array.isArray(prev) ? prev : [];
      return validPrev.filter((item, imgIndex) => imgIndex !== index);
    });
  };

  const handleServiceTitleChange = (index, value) => {
    formik.setFieldValue(`business_services[${index}].title`, value);
  };

  const handleServiceDescriptionChange = (index, value) => {
    formik.setFieldValue(`business_services[${index}].description`, value);
  };

  const handleServicePriceChange = (index, value) => {
    formik.setFieldValue(`business_services[${index}].price`, value);
  };

  const handleReorder = (sourceIndex, destinationIndex, formik) => {
    const items = [...formik.values.business_services];
    const [movedItem] = items.splice(sourceIndex, 1);
    items.splice(destinationIndex, 0, movedItem);

    const updatedItems = items.map((item, index) => ({
      ...item,
      display_order: index + 1,
    }));

    formik.setFieldValue("business_services", updatedItems);
  };

  useEffect(() => {
    if (formIsEdit) {
      setDataInFormik();
      setStatus({ label: getStatusLabel(editData?.is_active), value: editData?.is_active });
    } else if (formIsEdit === false) {
      setProfileImage({
        url: null,
        name: null,
      });
      setServiceProfile({
        url: null,
        name: null,
      });
    }
  }, []);

  // add, update businessdata api //
  const handleSubmit = async (value) => {
    if (!formIsEdit) {
      let response = await addBusinessApi(value);
      if (response?.status === 200) {
        setOpen(false);
        setFormIsEdit(false);
        getbusinessAllData();
        setNotification({
          color: "success",
          icon: "check",
          title: "Success",
          content: response.data.message,
          open: true,
        });
      } else {
        setNotification({
          color: "error",
          icon: "cancel",
          title: "Error",
          content: response.data.message,
          open: true,
        });
      }
    } else {
      let editresponse = await updateBusinessDataApi(value);
      if (editresponse?.status === 200) {
        setOpen(false);
        getbusinessAllData();
        setNotification({
          color: "success",
          icon: "check",
          title: "Success",
          content: editresponse.data.message,
          open: true,
        });
      } else {
        setNotification({
          color: "error",
          icon: "cancel",
          title: "Error",
          content: editresponse.data.message,
          open: true,
        });
      }
    }
  };

  const handleAddServices = () => {
    const currentService = formik?.values?.business_services;

    const newService = [...currentService, { title: "", description: "", price: "", logo: "" }];
    formik.setFieldValue("business_services", newService);
  };

  const handleStatusChange = (value) => {
    if (value) {
      formik.setFieldValue("is_active", value.value);
      setStatus(value);
    } else {
      formik.setFieldValue("is_active", null);
      setStatus(null);
    }
  };

  const getCategoryLabel = (id) => {
    const category = categoriesList.find((item) => item.id === id);
    return category ? category.label : "-";
  };

  const getSubCategoryLabel = (id) => {
    const subCategory = subCategoriesList.find((item) => item.id === id);
    return subCategory ? subCategory.label : "-";
  };

  const getMemberLabel = (id) => {
    const member = parentMemberList.find((item) => item.value === id);
    return member ? member.label : "-";
  };

  useEffect(() => {
    if (formIsEdit) {
      setCategory(
        editData.category_id
          ? { label: getCategoryLabel(editData.category_id), value: editData.category_id }
          : null
      );
      setSubCategory(
        editData.subcategory_id
          ? { label: getSubCategoryLabel(editData.subcategory_id), value: editData.subcategory_id }
          : null
      );
      setMember(
        editData.member_id
          ? { label: getMemberLabel(editData.member_id), value: editData.member_id }
          : null
      );
      const lat = editData?.latitude;
      const lng = editData?.longitude;
      setSelectedPosition({ lat, lng });
    }
  }, []);

  const handleCategoryValue = (value) => {
    setSubCategory(null);
    formik.setFieldValue("subcategory_id", null);
    if (value) {
      formik.setFieldValue("category_id", value.id);
      setCategory(value);
    } else {
      formik.setFieldValue("category_id", null);
      setCategory(null);
    }
  };

  const handleSubcategoryValue = (value) => {
    if (value) {
      formik.setFieldValue("subcategory_id", value.id);
      setSubCategory(value);
    } else {
      formik.setFieldValue("subcategory_id", null);
      setSubCategory(null);
    }
  };

  const formik = useFormik({
    initialValues: formIsEdit ? editData : initialValues,
    validationSchema: ValidationSchema,
    onSubmit: handleSubmit,
  });

  const handleMember = async (data) => {
    formik.setFieldValue("member_id", data?.value);
    setMember(data?.label);
  };

  const handleIsVerified = (e) => {
    setIsVerified(e?.target?.checked);
    formik.setFieldValue("is_verified", e?.target?.checked ? 1 : 0);
  };

  const handlePhoneValueChange = (newPhone) => {
    setPhoneNumber(newPhone?.numberValue);
    formik.setFieldValue("country_code", newPhone?.countryCallingCode);
    formik.setFieldValue("phone_number", newPhone?.nationalNumber);
  };

  const handleWhatsAppValueChange = (newPhone) => {
    setWhatsAppNumber(newPhone?.numberValue);
    formik.setFieldValue("country_code", newPhone?.countryCallingCode);
    formik.setFieldValue("wp_number", newPhone?.nationalNumber);
  };

  const selectedCategoryData = async () => {
    const response = await getBusinessSubcategoriesApi({
      filters: {
        category_id: category?.id || editData?.category_id,
      },
    });
    if (response.status === 200) {
      setSubcategories(
        response.data.data.rows?.map((item) => ({
          id: parseInt(item?.id),
          label: item?.name,
        }))
      );
    }
  };

  useEffect(() => {
    selectedCategoryData();
  }, [category, editData]);

  return (
    <>
      <MDBox component="form" role="form" onSubmit={formik.handleSubmit}>
        <MDBox>
          <ImageUploader
            img={profileImage.url}
            folderName={"/business"}
            name={"logo"}
            fileName={"logo"}
            formik={formik}
            label="Business Image"
            sx={{
              width: "100px",
              height: "100px",
              objectFit: "cover",
              borderRadius: "50%",
              marginBottom: "16px",
            }}
            // required
          />
          {formik.touched.logo && formik.errors.logo && (
            <MDBox
              component="p"
              sx={{
                fontSize: "12px",
                marginLeft: "5px",
                color: "red",
              }}
            >
              {formik.errors.logo}
            </MDBox>
          )}
        </MDBox>
        <Grid container spacing={2} rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item xs={12} md={6} sx={{ marginTop: "10px" }}>
            <MDInput
              type="text"
              name="name"
              label="Business Name"
              variant="standard"
              value={formik.values.name}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              fullWidth
              required
            />
            {formik.touched.name && formik.errors.name && (
              <MDBox
                component="p"
                sx={{ fontSize: "12px", marginLeft: "5px", color: "red", marginTop: "5px" }}
              >
                {formik.errors.name}
              </MDBox>
            )}
          </Grid>
          <Grid item xs={12} md={6} sx={{ marginTop: "10px" }}>
            <MDInput
              type="text"
              name="owner_name"
              label="Business Owner Name"
              variant="standard"
              value={formik.values.owner_name}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              fullWidth
              required
            />
            {formik.touched.owner_name && formik.errors.owner_name && (
              <MDBox
                component="p"
                sx={{ fontSize: "12px", marginLeft: "5px", color: "red", marginTop: "5px" }}
              >
                {formik.errors.owner_name}
              </MDBox>
            )}
          </Grid>
        </Grid>
        <MDBox
          sx={{
            display: "flex",
            width: "100%",
            flexDirection: "column",
            "@media (min-width: 768px)": {
              display: "flex",
              flexDirection: "row",
              gap: "0 30px",
            },
          }}
        >
          <MDBox sx={{ width: "100%", paddingTop: "20px !important" }}>
            <MDSelectBox
              name="category_id"
              label="Business Category"
              multiple={false}
              defaultValue={category}
              options={categoriesList}
              handleChange={(value) => handleCategoryValue(value)}
              onBlur={formik.handleBlur}
              width="100%"
              required
            />
            {formik.touched.category_id && formik.errors.category_id && (
              <MDBox
                component="p"
                sx={{ fontSize: "12px", marginLeft: "5px", color: "red", marginTop: "5px" }}
              >
                {formik.errors.category_id}
              </MDBox>
            )}
          </MDBox>

          <MDBox sx={{ width: "100%", paddingTop: "20px !important" }}>
            <MDSelectBox
              name="subcategory_id"
              label="Business Subcategory"
              multiple={false}
              defaultValue={subCategory}
              options={subcategories ? subcategories : subCategoriesList}
              handleChange={(value) => handleSubcategoryValue(value)}
              onBlur={formik.handleBlur}
              width="100%"
              disabled={category?.length == 0 || category === null ? true : false}
              required
            />
            {formik.touched.subcategory_id && formik.errors.subcategory_id && (
              <MDBox
                component="p"
                sx={{ fontSize: "12px", marginLeft: "5px", color: "red", marginTop: "5px" }}
              >
                {formik.errors.subcategory_id}
              </MDBox>
            )}
          </MDBox>
        </MDBox>
        <Grid item xs={12} md={6} sx={{ paddingTop: "20px !important" }}>
          <MDInput
            name="about"
            variant="standard"
            value={formik.values.about}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            multiline
            rows={4}
            fullWidth
            label="About Business"
          />
        </Grid>
        <Grid item xs={12} md={6} sx={{ paddingTop: "20px !important" }}>
          <MDSelectBox
            name="member_id"
            defaultValue={member}
            options={parentMemberList}
            handleChange={(value) => handleMember(value)}
            label="Head Member"
            width="100%"
            isImage={true}
            multiple={false}
            onBlur={formik.handleBlur}
            required
          />
          {formik.touched.member_id && formik.errors.member_id && (
            <MDBox
              component="p"
              sx={{ fontSize: "12px", marginLeft: "5px", color: "red", marginTop: "5px" }}
            >
              {formik.errors.member_id}
            </MDBox>
          )}
        </Grid>

        <Grid item xs={12} md={6} sx={{ paddingTop: "20px !important" }}>
          <MDTextField
            name="address"
            variant="standard"
            value={formik.values.address}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            multiline
            rows={4}
            fullWidth
            label="Business Address"
            required
          />
          {formik.touched.address && formik.errors.address && (
            <MDBox
              component="p"
              sx={{ fontSize: "12px", marginLeft: "5px", color: "red", marginTop: "5px" }}
            >
              {formik.errors.address}
            </MDBox>
          )}
        </Grid>

        <Grid item xs={12} md={6} sx={{ paddingTop: "30px !important", position: "relative" }}>
          <MDGoogleMap
            selectedPosition={{ lat: formik.values.latitude, lng: formik.values.longitude }}
            formik={formik}
            formikKeyName="address"
          />
        </Grid>
        <MDBox
          sx={{
            display: "flex",
            width: "100%",
            flexDirection: "column",
            "@media (min-width: 768px)": {
              display: "flex",
              flexDirection: "row",
              gap: "0 30px",
            },
          }}
        >
          <MDBox sx={{ width: "100%", paddingTop: "20px !important" }}>
            <MDTelInput
              name="phone_number"
              value={phoneNumber}
              handleChange={(event) => handlePhoneValueChange(event)}
              onBlur={formik.handleBlur}
              label="Mobile No"
              sx={{ width: "100%" }}
              variant="standard"
              required
            />
            {formik.touched.phone_number && formik.errors.phone_number && (
              <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                {formik.errors.phone_number}
              </MDBox>
            )}
          </MDBox>
          <MDBox sx={{ width: "100%", paddingTop: "20px !important" }}>
            <MDTelInput
              name="wp_number"
              value={whatsAppNumber}
              handleChange={(event) => handleWhatsAppValueChange(event)}
              onBlur={formik.handleBlur}
              label="WhatsApp Number"
              sx={{ width: "100%" }}
              variant="standard"
              required
            />
            {formik.touched.wp_number && formik.errors.wp_number && (
              <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                {formik.errors.wp_number}
              </MDBox>
            )}
          </MDBox>
        </MDBox>
        <MDBox sx={{ paddingTop: "20px !important" }}>
          <MDInput
            type="text"
            name="email"
            label="Business Email"
            variant="standard"
            value={formik.values.email}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            fullWidth
            required
          />
          {formik.touched.email && formik.errors.email && (
            <MDBox
              component="p"
              sx={{ fontSize: "12px", marginLeft: "5px", color: "red", marginTop: "5px" }}
            >
              {formik.errors.email}
            </MDBox>
          )}
        </MDBox>

        <Grid item xs={12} md={12} sx={{ paddingTop: "30px !important" }}>
          <MDBox component="h2" sx={{ fontSize: "20px", fontWeight: "500" }}>
            Business Services
          </MDBox>
          <DraggableServiceForm
            handleRemoveService={handleRemoveService}
            formik={formik}
            handleServiceTitleChange={handleServiceTitleChange}
            handleServiceDescriptionChange={handleServiceDescriptionChange}
            handleReorder={handleReorder}
            handleServicePriceChange={handleServicePriceChange}
            setServiceProfile={setServiceProfile}
            serviceProfile={serviceProfile}
          />
          <Grid item xs={12} md={12} mt={1} sx={{ display: "flex", justifyContent: "end" }}>
            <SubmitButton
              onClick={handleAddServices}
              btnText={
                <>
                  <Iconify icon="solar:add-square-bold" />
                  Add Product or Service
                </>
              }
            />
          </Grid>
        </Grid>

        <MDBox component="h2" sx={{ fontSize: "20px", fontWeight: "500", marginTop: "29px" }}>
          Social Media Links
        </MDBox>
        <Grid container spacing={2} rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item xs={12} md={6} sx={{ paddingTop: "20px !important" }}>
            <MDInput
              type="text"
              name="link"
              label="Business Website Link"
              variant="standard"
              value={formik.values.link}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              fullWidth
            />
            {formik.touched.link && formik.errors.link && (
              <MDBox
                component="p"
                sx={{ fontSize: "12px", marginLeft: "5px", color: "red", marginTop: "5px" }}
              >
                {formik.errors.link}
              </MDBox>
            )}
          </Grid>
          <Grid item xs={12} md={6} sx={{ paddingTop: "20px !important" }}>
            <MDInput
              type="text"
              name="facebook_link"
              label="Facebook Link"
              variant="standard"
              value={formik.values.facebook_link}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              fullWidth
            />
            {formik.touched.facebook_link && formik.errors.facebook_link && (
              <MDBox
                component="p"
                sx={{ fontSize: "12px", marginLeft: "5px", color: "red", marginTop: "5px" }}
              >
                {formik.errors.facebook_link}
              </MDBox>
            )}
          </Grid>
          <Grid item xs={12} md={6} sx={{ paddingTop: "20px !important" }}>
            <MDInput
              type="text"
              name="instagram_link"
              label="Instagram Link"
              variant="standard"
              value={formik.values.instagram_link}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              fullWidth
            />
            {formik.touched.instagram_link && formik.errors.instagram_link && (
              <MDBox
                component="p"
                sx={{ fontSize: "12px", marginLeft: "5px", color: "red", marginTop: "5px" }}
              >
                {formik.errors.instagram_link}
              </MDBox>
            )}
          </Grid>
          <Grid item xs={12} md={6} sx={{ paddingTop: "20px !important" }}>
            <MDInput
              type="text"
              name="youtube_link"
              label="YouTube Link"
              variant="standard"
              value={formik.values.youtube_link}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              fullWidth
            />
            {formik.touched.youtube_link && formik.errors.youtube_link && (
              <MDBox
                component="p"
                sx={{ fontSize: "12px", marginLeft: "5px", color: "red", marginTop: "5px" }}
              >
                {formik.errors.youtube_link}
              </MDBox>
            )}
          </Grid>

          <Grid item xs={12} md={6} sx={{ paddingTop: "20px !important" }}>
            <MDInput
              type="text"
              name="linkedin_link"
              label="LinkedIn Link"
              variant="standard"
              value={formik.values.linkedin_link}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              fullWidth
            />
            {formik.touched.linkedin_link && formik.errors.linkedin_link && (
              <MDBox
                component="p"
                sx={{ fontSize: "12px", marginLeft: "5px", color: "red", marginTop: "5px" }}
              >
                {formik.errors.linkedin_link}
              </MDBox>
            )}
          </Grid>
          <Grid item xs={12} md={6} sx={{ paddingTop: "20px !important" }}>
            <MDSelectBox
              name="is_active"
              defaultValue={status}
              options={statusData}
              handleChange={(value) => handleStatusChange(value)}
              label="Status"
              multiple={false}
              width="100%"
              onBlur={formik.handleBlur}
              required
            />
            {formik.touched.is_active && formik.errors.is_active && (
              <MDBox
                component="p"
                sx={{ fontSize: "12px", marginLeft: "5px", color: "red", marginTop: "5px" }}
              >
                {formik.errors.is_active}
              </MDBox>
            )}
          </Grid>

          <Grid item xs={12} md={6} sx={{ paddingTop: "30px !important" }}>
            <SingleCheckbox
              xs={12}
              sm={12}
              md={12}
              name="is_verified"
              label={
                <>
                  This Business is verified
                  <br />
                  <span style={{ marginTop: "8px", display: "block" }}>
                    (આ વ્યવસાય વેરીફાઈ થયેલ છે)
                  </span>
                </>
              }
              onChange={(event) => handleIsVerified(event)}
              onBlur={formik.handleBlur}
              checked={isVerified}
            />
          </Grid>
        </Grid>
        <MDBox sx={{ width: "100%", textAlign: "center", marginTop: "40px" }}>
          <SubmitButton btnText={formIsEdit ? "Update" : "Add"} type="submit" />
        </MDBox>
      </MDBox>
    </>
  );
};

BusinessForm.propTypes = {
  getbusinessAllData: PropTypes.func.isRequired,
};

export default BusinessForm;
